import React, { useContext, useState, useEffect } from "react";
import client, { getData } from '../feathers'
import { LoggerContext } from "../logger";
import { ENUM_SERVICES } from "../Enums/ENUM_SERVICES";

const PersonContext = React.createContext();
const PersonSelectionContext = React.createContext();

const servicename = ENUM_SERVICES.PERSONS;
const listenernames = ['created', 'patched'];
const providername = 'PersonProvider';

export function usePersonList() {
    return useContext(PersonContext);
}
export function usePersonSelectionList() {
    return useContext(PersonSelectionContext);
}

export function PersonProvider({ children }) {
    const [list, setList] = useState(null);
    const [listSelection, setListSelection] = useState([]);
    const [mounted, setMounted] = useState(false)

    const getPersonList = async () => {
        await getData(servicename).then((list) => {
            setList(list);
            LoggerContext.info(`########### ${providername} useEffect found:${list.length}`);
        }).catch((error) => { LoggerContext.error("Error " + providername, error) });
    }

    const removeListener = () => {
        const service = client.service(servicename);
        listenernames.forEach((listener) => {
            service.removeListener(listener);
        })
    }

    useEffect(() => {
        setMounted(true)
        const service = client.service(servicename);
        listenernames.forEach((listener) => {
            service.removeListener(listener);
            service.on(listener, getPersonList);
        })
    }, [])

    useEffect(() => {
        if (mounted) {
            getPersonList()
            return () => { LoggerContext.debug(`########### ${providername} ---- unload`); removeListener(); }
        }
    }, [mounted])

    return (
        <PersonContext.Provider value={list}>
            <PersonSelectionContext.Provider value={listSelection}>
                {children}
            </PersonSelectionContext.Provider>
        </PersonContext.Provider>
    )
}